import { makeStyles } from 'beam/dist/styles'

const useEvaluationFormStyles = makeStyles(theme => ({
  formWrapper: {
    height: '100%',
    overflow: 'scroll',
    '@media print': {
      overflow: 'visible',
    },
  },
  listBox: {
    maxHeight: (props: { maxListboxHeight: number }) => props.maxListboxHeight,
  },
  contactInfo: {
    display: 'none',
    '@media print': {
      display: 'block',
    },
  },
  header: {
    flex: '0 0 auto',
    position: 'sticky',
    top: 0,
    backgroundColor: '#fafafa',
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    padding: theme.spacing(2),
    zIndex: 10,
  },
  body: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.grey[200],
    overflow: 'auto',
    '@media print': {
      overflow: 'visible',
    },
  },
  formComments: {
    margin: 0,
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.background.paper,
  },
  score: {
    marginLeft: theme.spacing(0.5),
    lineHeight: 1,
    opacity: 1,
    visibility: 'visible',
  },
  scoreHide: {
    opacity: 0,
    visibility: 'hidden',
  },
  scoreProgress: {
    position: 'absolute',
    top: 0,
    right: theme.spacing(1),
    bottom: 0,
  },
  sectionWeight: {
    color: theme.palette.text.hint,
  },
  question: {
    marginTop: theme.spacing(2),
    position: 'relative',
  },
  questionWeight: {
    color: theme.palette.text.hint,
  },
  notification: {
    margin: theme.spacing(1, -2, -2),
    padding: theme.spacing(1, 2),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: upgrade to MUI v5 and move this this specific color into the theme as something like `notificationBackgroundColor`
    backgroundColor: (theme.palette as $TSFIXME).color.yellow[800],
  },
  stateChip: {
    height: theme.spacing(3),
  },
  section: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  sectionScore: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    marginLeft: theme.spacing(1),
    position: 'relative',
  },
  answerPoints: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.text.hint,
    fontWeight: theme.typography.fontWeightLight,
  },
  descriptionIcon: {
    marginBottom: '-7px',
    marginLeft: '5px',
    color: theme.palette.text.hint,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  descriptionContainer: {
    display: 'inline',
  },
  inlinePopper: {
    display: 'inline',
  },
} as const))

export default useEvaluationFormStyles
